// extracted by mini-css-extract-plugin
module.exports = {"tagsForm":"TagsTable_tagsForm__22rmN","submitButton":"TagsTable_submitButton__31tCf"};